import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';

export const rail = style({
  listStyle: 'none',
  margin: '0 0 12px',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '6px',
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize['2xs'],
  letterSpacing: '0.2em',
});

export const node = style({
  color: vars.bright.primary.light,
  opacity: 0.45,
  selectors: {
    '&[data-state="completed"]': { color: vars.bright.secondary.default, opacity: 0.7 },
    '&[data-state="current"]': {
      color: vars.bright.secondary.default,
      opacity: 1,
      textShadow: `0 0 10px ${vars.bright.secondary.glow}`,
    },
  },
});

export const separator = style({
  color: vars.surface.border.glow,
  opacity: 0.6,
});
